import { Tooltip } from '@mantine/core'

import { VoENextActionOwner } from 'src/graphql/types/verificationOfEmployments'

import { nextActionVisual } from './nextActionIcons'
import { describeNextAction, type NextActionFields } from './nextActionText'

/**
 * Whose move it is on a verification: a calendar icon with the date of
 * automation's next step, or the reason's icon with the reason a person has
 * it. Renders nothing when there is nothing to say (see describeNextAction).
 */
const NextActionTag = ({ voe }: { voe: NextActionFields }) => {
  const text = describeNextAction(voe)
  if (!text) return null
  const { Icon, iconClass, labelClass, label } = nextActionVisual(text)
  const scheduled = text.owner === VoENextActionOwner.AUTOMATED

  return (
    <Tooltip label={text.sentence} withArrow>
      <span
        data-testid="next-action-tag"
        className="flex min-w-0 items-center gap-1.5 text-xs"
      >
        <Icon
          aria-label={label}
          className={`h-3.5 w-3.5 flex-shrink-0 ${iconClass}`}
        />
        <span className="min-w-0 truncate text-doubleNickel-gray-900">
          <span className={labelClass}>{label}</span>
          {scheduled && text.detail && (
            <span className="text-doubleNickel-gray-600"> {text.detail}</span>
          )}
        </span>
      </span>
    </Tooltip>
  )
}

export default NextActionTag
